<template>
  <div id="app">
    <div class="layout">
        <Layout>
            <Header>
              <LayoutHeader></LayoutHeader>
            </Header>
            <Content>
                <router-view/>
            </Content>
            <Footer v-if="!this.$store.state.showPay">
              <tuifooter></tuifooter>
            </Footer>
        </Layout>
       <BackTop v-if="!isMoblie" />
        <!-- <Side></Side> -->
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie"
import LayoutHeader from './pages/Layout/Header'
import LayoutFooter from './pages/Layout/Footer'
import tuifooter from '@/pages/Layout/tuifooter'
import Side from './pages/Side/Side'
import BackTop from './pages/Side/BackTop.vue'
import doPost from '@/pages/Helper/XHR.js'
var isMoblie = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent)
export default {
  metaInfo () {
      return {
      title: '跳转代理 - iP代理_动态代理iP_换IP软件_ip地址修改器',
      meta: [
        {
          name: 'keywords',
          content: '代理ip,ip代理,换ip软件,动态ip,静态ip,国内ip,怎么改ip地址,怎么换ip地址,更改ip,,更换ip,电脑怎么换ip,手机更换ip软件,安卓换ip软件'
        },
        {
          name: 'description',
          content: '跳转代理ip，全国动态ip代理一键切换，支持安卓 iOS，提供免费试用的爬虫代理 动态ip 静态ip代理 游戏代理ip'
        }
      ],
      link: [{
        rel: 'asstes',
        href: 'https://center.huashengdaili.com/'
      }]
    }
  },
  data(){
    return{
      isMoblie
    }
  },
  name: 'App',
  components: {LayoutHeader,LayoutFooter,Side,tuifooter,BackTop},
  mounted () {
    if ( !Array.prototype.forEach ) {
      Array.prototype.forEach = function forEach( callback, thisArg ) {

        var T, k;

        if ( this == null ) {
          throw new TypeError( "this is null or not defined" );
        }
        var O = Object(this);
        var len = O.length >>> 0;
        if ( typeof callback !== "function" ) {
          throw new TypeError( callback + " is not a function" );
        }
        if ( arguments.length > 1 ) {
          T = thisArg;
        }
        k = 0;

        while( k < len ) {

          var kValue;
          if ( k in O ) {

            kValue = O[ k ];
            callback.call( T, kValue, k, O );
          }
          k++;
        }
      };
    }
    window.addEventListener("scroll",() => {
        var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
        let dom = document.querySelector(".ivu-layout-header")
        if(scrollTop > 0) {
          if(this.$route.path === '/'){
            dom.classList.add('scrollHeader')
          }
        }
        if(scrollTop == 0) {
           if(this.$route.path === '/'){
             dom.classList.remove('scrollHeader')
           }
        }
    }),
    this.huasheng_Client()
    // this.checkTuiguang()
  },
  methods: {
    // C++ 客户端路由截取
    huasheng_Client () {
      if(window.location.search == '?channel=0714baidu') {
        console.log('客户端')
      }
      //注册
      if(window.location.search == '?channel=huashengdaili') {
        this.$router.push('/Register')
      }
      // 忘记密码
      if(window.location.search  == '?login=huashengdaili') {
        this.$router.push('/Login')
      }
      // 购买 套餐
      if(window.location.search == '?buy=huashengdaili') {
        this.$router.push('/Buy')
      }
      // 用户绑定 自动登录
      if(window.location.search.indexOf('dev=pc') > 0) {
        this.$router.push('Personal')
      }
    },
    // 移动推广
    checkTuiguang() {
      let ua = navigator.userAgent.toLowerCase()
      console.log('设备'+/mobile|android|iphone|ipad|phone/i.test(ua))
      if(/mobile|android|iphone|ipad|phone/i.test(ua)){
          window.location.href = "https://hsdlm.d553f.com/";
      }
    }
  }
}
</script>

<style lang="stylus">
*
 font-family MicrosoftYaHei
.scrollHeader
  position: fixed
  z-index 999
  box-shadow 0px 0px 25px #1f1f1f
  width 100%
  background #000
>>>.ivu-layout-header
  background linear-gradient(red, blue)
.layout
  padding-top 60px
  box-sizing border-box
@media (max-width:758px)
  .layout
    padding-top 40px
</style>



// WEBPACK FOOTER //
// src/App.vue